import { graphql } from "react-relay";

export const autopilotStatusUnstartedFragments = {
  org: graphql`
    fragment AutopilotStatusUnstarted_org on Org
    @argumentDefinitions(timeZone: { type: "String!" }) {
      id
      nextDefragTime {
        ... on DefragTime {
          millis
        }
      }
      autopilotEventsResponse(timeZone: $timeZone) {
        __typename
        ... on AutopilotEventsResponse {
          enabledOrganized {
            eventParentRelayId
            paused
          }
          enabledAttending {
            eventParentRelayId
            paused
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};
